module.exports = __webpack_public_path__ + "static/consumable-328717b9310e4d75404ec68f34703cea.png";